
module.directive('datepicker', function(moment) {
    return {
        restrict: 'E',
        transclude: true,
        templateUrl: 'util/dates/datepicker',
        require: ['ngModel', 'datepicker', "?formField"],
        scope: {},
        link: function(scope, element, attrs, controllers) {
            var ngModel = controllers[0],
                datepicker = controllers[1],
                formFieldController = controllers[2];

            if (formFieldController) {
                formFieldController.focus = function() {
                    element.find('input')[0].focus()
                    return false;
                };
            }

            datepicker._setNgModel(ngModel);
        },
        controller: module.cC({

            inject: ['$scope', '$element', '$document', "$timeout", 'Page'],

            data: {
                datepicker: '{}',
            },

            init: function() {
                this.$element.bind('keydown', this._keydown);
                this.$element[0].addEventListener('focus', this._focus, true);
                this.$element.bind('focusout', this._blur);
                this.$.placeholder = "Type date";
            },

            methods: {

                formatValue: function(date) {
                    if (!date) {
                        return "Pick Date";
                    }
                    if (!moment.isMoment(date)) {
                        date = moment(date);
                    }
                    if (!date.isValid()) {
                        return "Pick Date";
                    }
                    return date.format('LL');
                },

                open: function() {
                    this._setDropdownState(true);
                    this._scrollIntoView(true);
                },

                close: function() {
                    this.datepicker.asText = "";
                    this._setDropdownState(false);
                },

                clear: function() {
                    this.datepicker.date = undefined;
                    this.selectAndClose(undefined);
                },

                cancel: function() {
                    this.ngModel.$rollbackViewValue();
                    this.close();
                },

                today: function() {
                    this.datepicker.date = moment();
                },

                select: function(date) {
                    this.ngModel.$setViewValue(date);
                },

                viewClick: function(date) {
                    if (!this.Page.isMobile()) {
                        this.$element.find('input')[0].focus();
                        this.$.placeholder = "Type date";
                    } else {
                        this.$.placeholder = "Tap to type date";
                    }
                    this.open();
                },

                selectAndClose: function(date) {
                    if (date) {
                        date = moment(date);
                        date = date.isValid() ? date : null;
                    }
                    this.select(date);
                    this.close();
                },

                approveDate: function() {
                    this.selectAndClose(this.datepicker.date);
                },

                changeText: function(text) {
                    if (!this.$.isOpen) {
                        this.open();
                    }
                    if (!text) { return; }
                    var date = moment(new Date(text));
                    if (date.isValid()) {
                        this.datepicker.date = date;
                    }
                },

                _scrollIntoView: function(useTimeout) {
                    if (useTimeout) {
                        this.$timeout(this._scrollIntoView);
                    } else {
                        this.Page.scrollToElement(this.$element);
                    }
                },

                _keydown: function(event) {
                    if (this.$.isOpen) {
                        if (event.which === 13) {
                            this._apply(this.approveDate);
                            event.preventDefault();
                        } else if (event.which === 9) { // Enter or tab
                            this._apply(this.approveDate);
                        } else if(event.which === 27) { // ESC
                            this._apply(this.cancel);
                        }
                    } else {
                        if (event.which === 13 ||
                                event.which === 32 ||
                                event.which === 40) { // enter, space, or down
                            this._apply(this.open);
                            event.preventDefault();
                        }
                    }
                },

                _focus: function(event) {
                    this.$element.addClass('focus');
                },

                _blur: function(event) {
                    this.$element.removeClass('focus');
                },

                _documentClick: function(event) {
                    if (!this.$element[0].contains(event.target)) {
                        this._apply(this.approveDate);
                    }
                },

                _apply: function(func) {
                    args = Array.prototype.slice.call(arguments, 1);
                    args.unshift(this);
                    this.$.$apply(func.bind.apply(func, args));
                },

                _setNgModel: function(ngModel) {
                    this.ngModel = ngModel;
                    this.ngModel.$render = this._ngModelRender;
                },

                _ngModelRender: function() {
                    if (this.ngModel.$viewValue) {
                        this.datepicker.date = moment(this.ngModel.$viewValue);
                    } else {
                        this.ngModel.viewValue = null;
                    }
                },

                _setDropdownState: function(open) {
                    this.$.isOpen = open;
                    this.$element.toggleClass('open', open);
                    if (open) {
                        this.$document.bind('mousedown', this._documentClick);
                    } else {
                        this.$document.unbind('mousedown', this._documentClick);
                    }
                }
            }
        }),
    };
});
